const NOMINATIM_API = 'https://nominatim.openstreetmap.org/search';

let lastApiCallTime = 0;
const MIN_API_INTERVAL = 800;

const apiCache = new Map();


const topCities = [
  'Berlin', 'Hamburg', 'München', 'Köln', 'Frankfurt', 'Stuttgart',
  'Düsseldorf', 'Dortmund', 'Essen', 'Leipzig', 'Bremen', 'Dresden',
  'Hannover', 'Nürnberg', 'Duisburg', 'Bochum', 'Wuppertal', 'Bielefeld',
  'Bonn', 'Münster', 'Karlsruhe', 'Mannheim', 'Augsburg', 'Wiesbaden',
  'Gelsenkirchen', 'Mönchengladbach', 'Braunschweig', 'Chemnitz', 'Kiel',
  'Aachen', 'Halle', 'Magdeburg', 'Freiburg', 'Krefeld', 'Lübeck',
  'Oberhausen', 'Erfurt', 'Mainz', 'Rostock', 'Kassel', 'Hagen',
  'Hamm', 'Saarbrücken', 'Mülheim', 'Potsdam', 'Ludwigshafen',
  'Oldenburg', 'Leverkusen', 'Osnabrück', 'Solingen',
  'Dormagen', 'Neuss', 'Ratingen', 'Hilden', 'Grevenbroich', 'Monheim',
  'Langenfeld', 'Erkrath', 'Meerbusch', 'Kaarst'
];

const internationalCities = {
  'paris': { name: 'Paris', country: 'Frankreich', lat: 48.8566, lng: 2.3522, count: 10 },
  'london': { name: 'London', country: 'Vereinigtes Königreich', lat: 51.5074, lng: -0.1278, count: 10 },
  'amsterdam': { name: 'Amsterdam', country: 'Niederlande', lat: 52.3676, lng: 4.9041, count: 10 },
  'wien': { name: 'Wien', country: 'Österreich', lat: 48.2082, lng: 16.3738, count: 10 },
  'vienna': { name: 'Wien', country: 'Österreich', lat: 48.2082, lng: 16.3738, count: 10 },
  'barcelona': { name: 'Barcelona', country: 'Spanien', lat: 41.3851, lng: 2.1734, count: 10 },
  'rom': { name: 'Rom', country: 'Italien', lat: 41.9028, lng: 12.4964, count: 10 },
  'rome': { name: 'Rom', country: 'Italien', lat: 41.9028, lng: 12.4964, count: 10 },
  'prag': { name: 'Prag', country: 'Tschechien', lat: 50.0755, lng: 14.4378, count: 8 },
  'prague': { name: 'Prag', country: 'Tschechien', lat: 50.0755, lng: 14.4378, count: 8 },
  'brüssel': { name: 'Brüssel', country: 'Belgien', lat: 50.8503, lng: 4.3517, count: 8 },
  'brussels': { name: 'Brüssel', country: 'Belgien', lat: 50.8503, lng: 4.3517, count: 8 },
  'kopenhagen': { name: 'Kopenhagen', country: 'Dänemark', lat: 55.6761, lng: 12.5683, count: 8 },
  'copenhagen': { name: 'Kopenhagen', country: 'Dänemark', lat: 55.6761, lng: 12.5683, count: 8 },
  'stockholm': { name: 'Stockholm', country: 'Schweden', lat: 59.3293, lng: 18.0686, count: 8 },
  'lissabon': { name: 'Lissabon', country: 'Portugal', lat: 38.7223, lng: -9.1393, count: 8 },
  'lisbon': { name: 'Lissabon', country: 'Portugal', lat: 38.7223, lng: -9.1393, count: 8 },
  'budapest': { name: 'Budapest', country: 'Ungarn', lat: 47.4979, lng: 19.0402, count: 8 },
  'zürich': { name: 'Zürich', country: 'Schweiz', lat: 47.3769, lng: 8.5417, count: 8 },
  'zurich': { name: 'Zürich', country: 'Schweiz', lat: 47.3769, lng: 8.5417, count: 8 },
  'new york': { name: 'New York', country: 'USA', lat: 40.7128, lng: -74.0060, count: 10 },
  'newyork': { name: 'New York', country: 'USA', lat: 40.7128, lng: -74.0060, count: 10 },
  'los angeles': { name: 'Los Angeles', country: 'USA', lat: 34.0522, lng: -118.2437, count: 8 },
  'losangeles': { name: 'Los Angeles', country: 'USA', lat: 34.0522, lng: -118.2437, count: 8 },
  'toronto': { name: 'Toronto', country: 'Kanada', lat: 43.6532, lng: -79.3832, count: 8 },
  'singapur': { name: 'Singapur', country: 'Singapur', lat: 1.3521, lng: 103.8198, count: 8 },
  'singapore': { name: 'Singapur', country: 'Singapur', lat: 1.3521, lng: 103.8198, count: 8 },
  'bangkok': { name: 'Bangkok', country: 'Thailand', lat: 13.7563, lng: 100.5018, count: 8 },
  'sydney': { name: 'Sydney', country: 'Australien', lat: -33.8688, lng: 151.2093, count: 8 }
};

export const searchCities = async (query) => {
  if (!query || query.trim().length === 0) return [];
  
  const trimmedQuery = query.trim();
  
  if (trimmedQuery.length < 2) {
    return [];
  }
  
  const blacklistedTerms = [
    'hitler', 'nazi', 'adolf', 'nsdap', 'ss', 'gestapo', 'holocaust',
    'hakenkreuz', 'reichs', 'führer', 'heil', 'arisch',
    'fuck', 'shit', 'porn', 'sex', 'dick', 'cock', 'pussy', 'ass',
    'bitch', 'bastard', 'cunt', 'wank', 'piss', 'arsch', 'fotze',
    'schwanz', 'nutte', 'hure', 'wichser', 'scheiße', 'scheisse',
    'fick', 'bumsen', 'penis', 'vagina', 'anal', 'oral',
    'nigger', 'negro', 'chink', 'slut', 'whore', 'retard',
    'faggot', 'tranny', 'gay', 'homo', 'lesbe', 'schwuchtel',
    'mongo', 'spast', 'behinderter', 'idiot', 'vollidiot',
    'arschloch', 'drecksau', 'hurensohn', 'motherfucker',
    'murder', 'kill', 'rape', 'terror', 'bomb', 'weapon',
    'drug', 'cocaine', 'heroin', 'meth', 'cannabis',
    'vergewaltigung', 'mord', 'töten', 'bombe', 'waffe',
    'droge', 'kokain',
    'test123', 'asdf', 'qwerty', 'xxxxx', 'aaaaa',
    '12345', '69420', 'penis123',
    'communist', 'fascist', 'terrorist', 'isis', 'taliban',
    'kommunist', 'faschist', 'terrorist',
    'satan', 'devil', 'porn', 'xxx', 'escort', 'hooker',
    'teufel', 'satan', 'porno',
  ];
  
  const queryLower = trimmedQuery.toLowerCase();
  
  const containsBlacklistedWord = blacklistedTerms.some(term => {
    const wordBoundaryRegex = new RegExp(`\\b${term}\\b`, 'i');
    return wordBoundaryRegex.test(queryLower);
  });
  
  if (containsBlacklistedWord) {
    return [];
  }
  
  try {
    let results = [];
    
    const internationalResults = searchInternationalCities(trimmedQuery);
    results.push(...internationalResults);
    
    if (trimmedQuery.length <= 4) {
      const apiResults = await searchWithSmartGuessing(trimmedQuery);
      results.push(...apiResults);
    } else {
      const [deResults, worldResults] = await Promise.all([
        searchCitiesAPI(trimmedQuery, 'de'),
        searchCitiesAPI(trimmedQuery, null)
      ]);
      results.push(...deResults, ...worldResults);
    }
    
    if (results.length === 0) {
      const localMatches = topCities
        .filter(city => {
          const cityLower = city.toLowerCase();
          return cityLower.startsWith(queryLower) || cityLower === queryLower;
        })
        .map(city => ({
          name: city,
          displayName: city,
          lat: 0, 
          lng: 0,
          type: 'city',
          state: '',
          importance: 0.7,
          isLocalMatch: true
        }));
      
      if (localMatches.length > 0) {
        results = localMatches;
      }
    }
    
    const uniqueResults = Array.from(
      new Map(results.map(item => [
        `${item.name.toLowerCase()}|${(item.county || '').toLowerCase()}|${(item.country || '').toLowerCase()}`
      , item])).values()
    );
    
    const queryLowerForFiltering = trimmedQuery.toLowerCase();
    
    if (uniqueResults.length < 5) {
      const additionalMatches = topCities
        .filter(city => {
          const cityLower = city.toLowerCase();
          const startsWithQuery = cityLower.startsWith(queryLowerForFiltering);
          const hasQueryAtWordStart = new RegExp(`\\b${queryLowerForFiltering}`, 'i').test(cityLower);
          const containsQuery = queryLowerForFiltering.length >= 4 && cityLower.includes(queryLowerForFiltering);
          
          return (startsWithQuery || hasQueryAtWordStart || containsQuery) && 
                 !uniqueResults.some(r => r.name.toLowerCase() === cityLower);
        })
        .map(city => ({
          name: city,
          displayName: city,
          lat: 0,
          lng: 0,
          type: 'city',
          state: '',
          importance: 0.5,
          isPartialMatch: true
        }));
      
      if (additionalMatches.length > 0) {
        uniqueResults.push(...additionalMatches);
      }
    }
    
    uniqueResults.sort((a, b) => {
      const aNameLower = a.name.toLowerCase();
      const bNameLower = b.name.toLowerCase();
      
      const aExact = aNameLower === queryLower;
      const bExact = bNameLower === queryLower;
      if (aExact && !bExact) return -1;
      if (!aExact && bExact) return 1;
      
      const aStarts = aNameLower.startsWith(queryLower);
      const bStarts = bNameLower.startsWith(queryLower);
      if (aStarts && !bStarts) return -1;
      if (!aStarts && bStarts) return 1;
      
      const aWordStart = new RegExp(`\\b${queryLower}`, 'i').test(aNameLower);
      const bWordStart = new RegExp(`\\b${queryLower}`, 'i').test(bNameLower);
      if (aWordStart && !bWordStart) return -1;
      if (!aWordStart && bWordStart) return 1;
      
      const aIsTop = topCities.some(c => c.toLowerCase() === aNameLower);
      const bIsTop = topCities.some(c => c.toLowerCase() === bNameLower);
      if (aIsTop && !bIsTop) return -1;
      if (!aIsTop && bIsTop) return 1;

      if (a.importance && b.importance) {
        return b.importance - a.importance;
      }

      return a.name.length - b.name.length;
    });
    
    return uniqueResults;
    
  } catch (error) {
    return [];
  }
};

const searchInternationalCities = (query) => {
  const queryLower = query.toLowerCase().trim();
  const results = [];
  const seen = new Set();
  
  if (internationalCities[queryLower]) {
    const city = internationalCities[queryLower];
    const displayName = `${city.name}, ${city.country}`;
    
    if (!seen.has(displayName)) {
      results.push({
        name: city.name,
        displayName: displayName,
        lat: city.lat,
        lng: city.lng,
        type: 'city',
        state: city.country,
        importance: 0.95,
        isInternational: true,
        toiletCount: city.count
      });
      seen.add(displayName);
    }
  }
  
  Object.entries(internationalCities).forEach(([key, city]) => {
    const displayName = `${city.name}, ${city.country}`;
    
    if (key.startsWith(queryLower) && !seen.has(displayName)) {
      results.push({
        name: city.name,
        displayName: displayName,
        lat: city.lat,
        lng: city.lng,
        type: 'city',
        state: city.country,
        importance: 0.9,
        isInternational: true,
        toiletCount: city.count
      });
      seen.add(displayName);
    }
  });
  
  if (queryLower.length >= 3) {
    Object.entries(internationalCities).forEach(([key, city]) => {
      const displayName = `${city.name}, ${city.country}`;
      
      if (key.includes(queryLower) && !seen.has(displayName)) {
        results.push({
          name: city.name,
          displayName: displayName,
          lat: city.lat,
          lng: city.lng,  
          type: 'city',
          state: city.country,
          importance: 0.85,
          isInternational: true,
          toiletCount: city.count
        });
        seen.add(displayName);
      }
    });
  }
  
  return results;
};

const searchWithSmartGuessing = async (query) => {
  const queryLower = query.toLowerCase();
  
  const matchingTopCities = topCities.filter(city => {
    const cityLower = city.toLowerCase();
    return cityLower.startsWith(queryLower) || 
           cityLower.includes(queryLower);
  });
  
  const searchPromises = [
    searchCitiesAPI(query, 'de'),
    searchCitiesAPI(query, null)
  ];
  
  if (matchingTopCities.length > 0) {
    searchPromises.push(searchCitiesAPI(matchingTopCities[0], 'de'));
  }
  
  const allResults = await Promise.all(searchPromises);
  return allResults.flat();
};

const searchCitiesAPI = async (query, countryCode = null) => {
  const queryKey = `search_${query}_${countryCode || 'world'}`;
  
  if (apiCache.has(queryKey)) {
    return apiCache.get(queryKey);
  }
  
  await waitForThrottle();
  
  const paramsObj = {
    q: query,
    format: 'json',
    addressdetails: 1,
    limit: 15,
    'accept-language': 'de',
  };
  
  if (countryCode) {
    paramsObj.countrycodes = countryCode;
  }
  
  const params = new URLSearchParams(paramsObj);
  
  const url = `${NOMINATIM_API}?${params}`;
  
  try {
    const response = await fetch(url, {
      headers: {
         'User-Agent': 'Restroom Advisor/1.8 (https://restroomadvisor.app)'
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }
    
    const data = await response.json();
    
    const cities = data
      .filter(item => {
        const type = item.type?.toLowerCase() || '';
        const placeClass = item.class?.toLowerCase() || '';
        const osmType = item.osm_type?.toLowerCase() || '';
        
        const blacklist = [
          'aerodrome', 'airport', 'station', 'railway', 'halt',
          'diplomatic', 'office', 'museum', 'tourism', 'amenity',
          'university', 'research', 'memorial', 'monument', 'building',
          'milestone', 'consulting', 'association', 'ngo', 'government',
          'water', 'highway', 'bus_stop', 'pedestrian', 'footway', 'path',
          'suburb'
        ];
        
        const isBlacklisted = blacklist.some(word => 
          type.includes(word) || placeClass.includes(word)
        );
        
        if (isBlacklisted) return false;
        
        const whitelist = [
          'city', 'town', 'village', 'municipality',
          'administrative', 'place', 'boundary', 'hamlet'
        ];
        
        const isWhitelisted = whitelist.some(word =>
          type.includes(word) || placeClass.includes(word)
        );
        
        const isRelation = osmType === 'relation';
        const adminLevel = item.extratags?.admin_level;
        const isValidAdmin = isRelation && adminLevel && 
                            parseInt(adminLevel) >= 4 && 
                            parseInt(adminLevel) <= 8;
        
        return isWhitelisted || isValidAdmin;
      })
      .map(item => {
        const isRealCity = item.type === 'city' || 
                          item.type === 'town' || 
                          item.type === 'village' ||
                          item.type === 'municipality' ||
                          item.type === 'hamlet';
        
        const name = isRealCity && item.name
                     ? item.name
                     : (item.address?.city ||
                        item.address?.town || 
                        item.address?.village || 
                        item.address?.municipality ||
                        item.address?.hamlet ||
                        item.name);
        
        const state = item.address?.state || '';
        const county = item.address?.county || item.address?.state_district || '';
        const country = item.address?.country || '';
        const countryCode = item.address?.country_code?.toUpperCase() || '';
        
        return {
          name: name,
          displayName: name,
          lat: parseFloat(item.lat),
          lng: parseFloat(item.lon),
          type: item.type,
          state: state,
          county: county,
          country: country,
          countryCode: countryCode,
          importance: item.importance || 0
        };
      })
      .filter(city => {
        const hasValidName = city.name && city.name.length > 0;
        
        const hasParentheses = city.name && city.name.includes('(');
        if (hasParentheses) {
          city.importance = (city.importance || 0) * 0.5;
        }
        
        return hasValidName;
      });
    
    apiCache.set(queryKey, cities);
    
    return cities;
    
  } catch (error) {
    return [];
  }
};

const waitForThrottle = async () => {
  const now = Date.now();
  const timeSinceLastCall = now - lastApiCallTime;
  
  if (timeSinceLastCall < MIN_API_INTERVAL) {
    const waitTime = MIN_API_INTERVAL - timeSinceLastCall;
    await new Promise(resolve => setTimeout(resolve, waitTime));
  }
  
  lastApiCallTime = Date.now();
};

export const geocodeAddress = async (address, city) => {
  try {
    const fullAddress = city ? `${address}, ${city}, Deutschland` : `${address}, Deutschland`;
    
    const url = `https://nominatim.openstreetmap.org/search?` + 
      `format=json&` +
      `q=${encodeURIComponent(fullAddress)}&` +
      `countrycodes=de&` +
      `limit=5&` +
      `addressdetails=1`;
    
    const response = await fetch(url, {
      headers: {
        'User-Agent': 'Restroom Advisor App',
        'Accept-Language': 'de'
      }
    });
    
    if (!response.ok) {
      throw new Error(`Nominatim API Error: ${response.status}`);
    }
    
    const data = await response.json();
    
    if (!data || data.length === 0) {
      const fallbackUrl = `https://nominatim.openstreetmap.org/search?` + 
        `format=json&` +
        `q=${encodeURIComponent(`${address}, ${city}`)}&` +
        `limit=5&` +
        `addressdetails=1`;
      
      const fallbackResponse = await fetch(fallbackUrl, {
        headers: {
          'User-Agent': 'Restroom Advisor App',
          'Accept-Language': 'de'
        }
      });
      
      const fallbackData = await fallbackResponse.json();
      
      if (fallbackData && fallbackData.length > 0) {
        const result = fallbackData[0];
        const coords = {
          lat: parseFloat(result.lat),
          lng: parseFloat(result.lon),
          display_name: result.display_name
        };
        return coords;
      }
      
      return null;
    }
    
    const result = data[0];
    const coords = {
      lat: parseFloat(result.lat),
      lng: parseFloat(result.lon),
      display_name: result.display_name
    };
    
    return coords;
    
  } catch (error) {
    return null;
  }
};

export const reverseGeocode = async (lat, lng) => {
  try {
    await waitForThrottle();
    
    const url = `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json&addressdetails=1&accept-language=de&zoom=18`;
    
    const response = await fetch(url, {
      headers: {
        'User-Agent': 'Restroom Advisor/1.0'
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }
    
    const data = await response.json();
    
    if (!data || !data.address) {
      return null;
    }
    
    const city = data.address.city 
      || data.address.town 
      || data.address.village 
      || data.address.municipality
      || data.address.county;
    
    if (!city) {
      return null;
    }
    
    const road = data.address.road || data.address.pedestrian || data.address.footway || '';
    const houseNumber = data.address.house_number || '';
    const postcode = data.address.postcode || '';
    
    let fullAddress = '';
    if (road && houseNumber) {
      fullAddress = postcode 
        ? `${road} ${houseNumber}, ${postcode} ${city}`
        : `${road} ${houseNumber}, ${city}`;
    } else if (road) {
      fullAddress = postcode 
        ? `${road}, ${postcode} ${city}`
        : `${road}, ${city}`;
    } else {
      fullAddress = city;
    }
    
    return {
      name: city,
      address: fullAddress,
      state: data.address.state,
      country: data.address.country,
      lat: parseFloat(data.lat),
      lng: parseFloat(data.lon),
      road: road,
      houseNumber: houseNumber,
      postcode: postcode
    };
    
  } catch (error) {
    return null;
  }
};

export const searchAddresses = async (query, city) => {
  if (!query || query.trim().length < 3) return [];
  
  const trimmedQuery = query.trim();
  
  try {
    await waitForThrottle();
    
    const searchQuery = `${trimmedQuery}, Deutschland`;
    
    const params = new URLSearchParams({
      q: searchQuery,
      format: 'json',
      addressdetails: 1,
      limit: 30,
      countrycodes: 'de',
      'accept-language': 'de',
      dedupe: 0,
    });
    
    const url = `${NOMINATIM_API}?${params}`;
    
    const response = await fetch(url, {
      headers: {
        'User-Agent': 'RestroomAdvisor/1.8 (https://restroomadvisor.app)'
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }
    
    const data = await response.json();
    
    const addresses = data
      .filter(item => {
        const hasStreet = item.address?.road || item.address?.pedestrian || item.address?.footway;
        
        const isBuilding = item.type === 'building' || 
                          item.type === 'station' || 
                          item.type === 'railway_station' ||
                          item.type === 'amenity' ||
                          item.type === 'railway' ||
                          item.type === 'public_transport';
        
        const isPOI = item.class === 'amenity' || 
                     item.class === 'railway' ||
                     item.class === 'building' ||
                     item.class === 'highway' ||
                     item.class === 'place';
        
        const hasAddress = item.address && (
          item.address.road || 
          item.address.city || 
          item.address.town || 
          item.address.village ||
          item.address.suburb ||
          item.name
        );
        
        const isTooGeneral = item.type === 'country' || 
                            item.type === 'continent' ||
                            item.type === 'state';
        
        return (hasStreet || isBuilding || isPOI || hasAddress) && !isTooGeneral;
      })
      .map(item => {
        const road = item.address?.road || item.address?.pedestrian || item.address?.footway || '';
        const houseNumber = item.address?.house_number || '';
        const postcode = item.address?.postcode || '';
        const cityName = item.address?.city || item.address?.town || item.address?.village || item.address?.municipality || '';
        const suburb = item.address?.suburb || '';
        const name = item.address?.name || item.name || '';
        
        let fullAddress = '';
        
        if (name && road && houseNumber) {
          fullAddress = postcode 
            ? `${name}, ${road} ${houseNumber}, ${postcode} ${cityName}`
            : `${name}, ${road} ${houseNumber}, ${cityName}`;
        } else if (road && houseNumber) {
          fullAddress = postcode 
            ? `${road} ${houseNumber}, ${postcode} ${cityName}`
            : `${road} ${houseNumber}, ${cityName}`;
        } else if (name && cityName && name !== cityName) {
          fullAddress = `${name}, ${cityName}`;
        } else if (road) {
          fullAddress = suburb 
            ? `${road}, ${suburb}, ${cityName}`
            : `${road}, ${cityName}`;
        } else if (name) {
          fullAddress = `${name}, ${cityName}`;
        } else {
          fullAddress = item.display_name;
        }
        
        return {
          address: fullAddress,
          displayName: item.display_name,
          lat: parseFloat(item.lat),
          lng: parseFloat(item.lon),
          type: item.type,
          name: name,
          city: item.address.city || item.address.town || item.address.municipality || item.address.village
        };
      })
      .filter(addr => addr.address && addr.address.length > 0);
    
    const uniqueAddresses = [];
    const seen = new Set();
    
    for (const addr of addresses) {
      const normalized = addr.address.toLowerCase().replace(/\s+/g, '');
      
      if (!seen.has(normalized)) {
        seen.add(normalized);
        uniqueAddresses.push(addr);
      }
    }
    
    uniqueAddresses.sort((a, b) => {
      const aHasNumber = /\d/.test(a.address);
      const bHasNumber = /\d/.test(b.address);
      
      if (aHasNumber && !bHasNumber) return -1;
      if (!aHasNumber && bHasNumber) return 1;
      return 0;
    });
    
    return uniqueAddresses;
    
  } catch (error) {
    return [];
  }
};